import { createStackNavigator } from '@react-navigation/stack'

import { useTranslation } from '~hooks'
import { HistoryScreen } from '~screens'
import { Routes } from '~types/routesNames'

const { Navigator, Screen } = createStackNavigator<HistoryStackParamList>()

export const HistoryStack = (): JSX.Element => {
  const { t } = useTranslation()
  return (
    <Navigator>
      <Screen
        name={Routes.History}
        options={{ title: t('navigation.screen_titles.wallet_stack'), headerShown: false }}
        component={HistoryScreen}
      />
    </Navigator>
  )
}
